import type { ReactNode } from 'react'
import { Avatar } from './Avatar'
import styles from './SummaryStrip.module.css'

interface SummaryStripProps {
  name: string
  title?: string
  subtitle: ReactNode
  /** Right-hand slot: a pill or a link-style button. */
  aside?: ReactNode
}

/** Muted summary of a person at the top of a modal (attach step 2, grant confirm, revoke). */
export function SummaryStrip({ name, title, subtitle, aside }: SummaryStripProps) {
  return (
    <div className={styles.strip}>
      <Avatar name={name} size={40} />
      <div className={styles.text}>
        <div className={styles.title}>{title ?? name}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      {aside}
    </div>
  )
}
